var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-inputs" }, [
    _c("div", { staticClass: "form-group search-location" }, [
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query",
            },
          ],
          ref: "locationSearch",
          class: [
            "form-control real-input",
            { "mobile-form-control": _vm.screenType === "mobile" },
          ],
          attrs: {
            type: "text",
            placeholder: _vm.trans(
              "booking-process.location_search.pickup_location"
            ),
            tabindex: "1",
            "data-cy": "search-location",
            disabled: _vm.locked,
          },
          domProps: { value: _vm.query },
          on: {
            focus: function ($event) {
              return _vm.wasFocused()
            },
            blur: function ($event) {
              return _vm.wasBlurred()
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.query = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "script",
        { attrs: { type: "text/template", id: "location-search-template" } },
        [
          _vm._v(
            '\n            <div class="location-search-dropdown">\n              <div class="aa-dataset-d1"></div>\n              <button type="button" id="show-more-locations-button">' +
              _vm._s(_vm.trans("greenmotion.home.show_more_options")) +
              "</button>\n            </div>\n        "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.dropoffLocations.length && !_vm.disableDropoffDropdown
      ? _c("div", { staticClass: "mb-4" }, [
          _c(
            "div",
            {
              staticClass:
                "form-group search-location with-navigation-icon mb-0",
            },
            [
              _c("div", [
                _c("label", { attrs: { for: "dropofflocation" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.trans(
                        "booking-process.location_search.dropoff_location"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  class: [
                    "form-control dropoff-location",
                    { "mobile-form-control": _vm.screenType === "mobile" },
                  ],
                  attrs: {
                    type: "text",
                    placeholder: _vm.trans(
                      "booking-process.location_search.choose_location"
                    ),
                    tabindex: "2",
                    id: "dropofflocation",
                    readonly: "",
                  },
                  domProps: { value: _vm.dropoffLocationName },
                  on: {
                    focus: function ($event) {
                      _vm.dropoffSuggestions = true
                    },
                    blur: _vm.hideDropoffSuggestions,
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dropoff-dropdown-container" }, [
            _vm.dropoffSuggestions
              ? _c(
                  "div",
                  { staticClass: "location-search-dropdown dropoff-dropdown" },
                  [
                    _c("div", { staticClass: "aa-dataset-d1" }, [
                      _c(
                        "span",
                        { staticClass: "aa-suggestions" },
                        _vm._l(
                          _vm.filteredDropoffLocations,
                          function (location) {
                            return _c(
                              "div",
                              {
                                key: location.id,
                                staticClass: "aa-suggestion",
                                class: {
                                  active:
                                    _vm.dropoffLocationName === location.name,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateDropoffLocation(location)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "aa-suggestion-location" },
                                  [_c("span", [_vm._v(_vm._s(location.name))])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "aa-suggestion-extra-details",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(location.country.name)),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }